export default __webpack_public_path__ + "static/media/html.6ce3cfed.svg";